import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

const InformationModalVariantEnum = Object.freeze({
  DANGER: {
    class: 'danger',
    icon: FaExclamationTriangle,
  },
  INFO: {
    class: 'info',
    icon: FaInfoCircle,
  },
  PRIMARY: {
    class: 'primary',
    icon: FaInfoCircle,
  },
  SUCCESS: {
    class: 'success',
    icon: FaCheckCircle,
  },
  WARNING: {
    class: 'warning',
    icon: FaExclamationCircle,
  },
});

export default InformationModalVariantEnum;
